import AchHelp from "../ach-help";
import classes from "../../classes";
import expandable from "../higher-order/expandable";
import FormError from "../form-error";
import { Map } from "immutable";
import React from "react";
import { withRouter } from "react-router-dom";

export default withRouter(expandable(class AchForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.toggleHelp = this.toggleHelp.bind(this);
  }

  onSubmit(e) {
    var { history, onSubmit, session, withdraw } = this.props;
    e.preventDefault();
    onSubmit(
      session,
      withdraw.get("amount"),
      this.refs.routingNumber.value,
      this.refs.accountNumber.value,
      history
    );
  }

  toggleHelp(e) {
    var { toggle } = this.props;
    e.preventDefault();
    toggle();
  }

  render() {
    var { communications, expanded, toggle, session } = this.props;

    var routingNumber;
    var accountNumber;
    var account = session.getIn(["checking_accounts", 0]);
    if (account) {
      routingNumber = account.get("routing_number");
      accountNumber = account.get("account_number");
    }

    var help;
    if (expanded) {
      help = <AchHelp onClose={toggle} />;
    }

    var loading = communications.getIn(["ach_withdraw", "state"]) === "in progress";
    var errors = communications.getIn(["ach_withdraw", "error"]) || Map();

    return (
      <form className="form--is-horizontal" onSubmit={this.onSubmit}>
        <div className="batch-g batch-g--padding batch-g--valign-center">

          <div className="batch-c-1-1 batch-c-md-1-4 text-right" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <h3>
              Automated Clearing House (ACH)
            </h3>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="routing-number">
              Routing Number
              {" "}

              <button className="dw-help_outline dw--1-25x" onClick={this.toggleHelp} type="button" />
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" defaultValue={routingNumber} id="routing-number" maxLength="9" name="routing-number" placeholder="Routing Number (Must be 9 digits.)" ref="routingNumber" type="number" />

            <FormError error={errors.get("routing_number")} name="Routing Number" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="account-number">
              Account Number
              {" "}

              <button className="dw-help_outline dw--1-25x" onClick={this.toggleHelp} type="button" />
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" defaultValue={accountNumber} id="account-number" name="account-number" placeholder="Account Number" ref="accountNumber" type="number" />

            <FormError error={errors.get("account_number")} name="Account Number" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="form_action">
              <input
                className={classes({
                  "btn": true,
                  "btn--primary": true,
                  "btn--is-loading": loading,
                })}
                disabled={loading}
                type="submit"
                value={loading ? "Processing" : "Payout Via ACH"} />
            </div>
          </div>
        </div>

        {help}
      </form>
    );
  }
}));
